import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoOffice = () => {
  return (
    <g>
      <path d="m9.879.16-8.434 3.256v9.406l.004.001 3.018-1.259v-7.409l5.464-1.261v11.034l-8.472-1.101 8.42 3.013 4.676-1.509v-12.596z" />
    </g>
  );
};

export default withIcon(IconLogoOffice);
